import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  FormHelperText,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { CloudUpload } from "@material-ui/icons";
import { apiJson } from "../../../../api/Api";
import { toast } from "react-toastify";
import DropzoneElement from "../../../../components/Dropzone/DropzoneElement";
import { type } from "../../../../components/Dropzone/type";
import { FileUploadPromise } from "../../../../utils/aws_s3/aws_s3";

let message = "";

const showError = () => {
  toast.error(message, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

const COUNTRIES = [
  { name: "United Arab Emirates", id: 1 },
  { name: "Saudi Arabia", id: 2 },
  { name: "Egypt", id: 3 },
];

const businessSchema = Yup.object({
  country_id: Yup.string().required("Country is required"),
  license_no: Yup.string().required("License number is required"),
  business_address: Yup.string().required("Business address is required"),

  businsess_license_file: Yup.string().required("License document is required"),
  vat_document: Yup.string().required("VAT document is required"),
});

const handleFilesChange = (e, name, formik) => {
  FileUploadPromise(e[0])
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        formik.setFieldValue(name, response?.location);
        // setFileName(e[0].name);
        // setUploadKey(response?.key);
        // setValues({
        //   ...values,
        //   image: response?.location,
        // });
      }
    })
    .catch((error) => {
      message = error
        ? error !== ""
          ? error
          : "something went wrong"
        : "something went wrong";
      showError();
    });
};

// const FileUploadField = ({ label, name, formik }) => (
//   <Box className="file-upload-wrapper">
//     <Typography className="file-upload-label">{label}</Typography>
//     {/* <label className="file-upload-zone">
//       <input
//         type="file"
//         accept=".pdf,image/*"
//         hidden
//         onChange={(e) => formik.setFieldValue(name, e.currentTarget.files[0])}
//         onBlur={() => formik.setFieldTouched(name, true)}
//       />
//       <CloudUpload className="file-upload-icon" />
//       <Typography className="file-upload-text">
//         {formik.values[name]
//           ? formik.values[name].name
//           : "Click or drag file here"}
//       </Typography>
//       <Typography className="file-upload-hint">
//         PDF or Image · Max 5MB
//       </Typography>
//     </label> */}

//     <DropzoneElement
//       multiple={false}
//       updateSelectedServiceFiles={(e) => handleFilesChange(e, name, formik)}
//       value={formik.values[name] ? formik.values[name].name : ""}
//       type={type.PDF}
//     />
//     {formik.touched[name] && formik.errors[name] && (
//       <FormHelperText error>{formik.errors[name]}</FormHelperText>
//     )}
//   </Box>
// );

const FileUploadField = ({ label, name, formik }) => (
  <Box className="file-upload-wrapper">
    <Typography className="file-upload-label">{label}</Typography>

    <Box className="file-upload-zone">
      {" "}
      {/* ← wraps Dropzone */}
      <CloudUpload className="file-upload-icon" />
      <DropzoneElement
        multiple={false}
        updateSelectedServiceFiles={(e) => handleFilesChange(e, name, formik)}
        value={formik.values[name] ? formik.values[name] : ""}
        type={type.PDF}
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          opacity: 0,
        }} // invisible but clickable on top
      />
    </Box>

    {formik.touched[name] && formik.errors[name] && (
      <FormHelperText error>{formik.errors[name]}</FormHelperText>
    )}
  </Box>
);

const BusinessStep = ({ onSuccess, onBack }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState();

  useEffect(() => {
    apiJson.vendorProfile.getVendor().then((response) => {
      if (response.success) {
        setUser(response.data);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      country_id: user?.store?.country_id ? user?.store?.country_id : 1,
      license_no: user?.store?.license_no,
      business_name: user?.store?.business_name,
      authorized_signatory_name_en: user?.store?.authorized_signatory_name_en,
      business_address: user?.store?.business_address,
      businsess_license_file: user?.store?.businsess_license_file,
      vat_document: user?.store?.vat_document,
    },
    validationSchema: businessSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await apiJson.onboarding.updateBusinessDetails(values);
        if (response.success) {
          toast.success("Business information saved successfully", {
            position: "bottom-right",
          });
          onSuccess();
        } else {
          toast.error(response.message || "Something went wrong", {
            position: "bottom-right",
          });
        }
      } catch (err) {
        toast.error(
          err?.response?.data?.message ||
            "Something went wrong. Please try again.",
          { position: "bottom-right" },
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Box className="step-wrapper">
      <Typography className="step-title">Business Registration</Typography>
      <Typography className="step-subtitle">
        Upload your trade license and VAT certificate to verify your business
        legally.
      </Typography>

      <form onSubmit={formik.handleSubmit} className="step-form">
        <TextField
          name="business_name"
          label="Business Name"
          placeholder="Enter your business name"
          fullWidth
          variant="outlined"
          value={formik.values.business_name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.business_name && Boolean(formik.errors.business_name)
          }
          helperText={
            formik.touched.business_name && formik.errors.business_name
          }
        />
        <TextField
          name="authorized_signatory_name_en"
          label="Authorized Representative Name"
          placeholder="Enter authorized representative name"
          fullWidth
          variant="outlined"
          value={formik.values.authorized_signatory_name_en}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.authorized_signatory_name_en &&
            Boolean(formik.errors.authorized_signatory_name_en)
          }
          helperText={
            formik.touched.authorized_signatory_name_en &&
            formik.errors.authorized_signatory_name_en
          }
        />
        <TextField
          name="country_id"
          label="Country"
          select
          fullWidth
          variant="outlined"
          value={formik.values.country_id}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.country_id && Boolean(formik.errors.country_id)}
          helperText={formik.touched.country_id && formik.errors.country_id}
        >
          {COUNTRIES.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          name="license_no"
          label="License Number"
          placeholder="Enter your license number"
          fullWidth
          variant="outlined"
          value={formik.values.license_no}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.license_no && Boolean(formik.errors.license_no)}
          helperText={formik.touched.license_no && formik.errors.license_no}
        />
        <TextField
          name="business_address"
          label="Business Address"
          placeholder="Enter your business address"
          fullWidth
          variant="outlined"
          multiline
          // rows={3}
          value={formik.values.business_address}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.business_address &&
            Boolean(formik.errors.business_address)
          }
          helperText={
            formik.touched.business_address && formik.errors.business_address
          }
        />
        <FileUploadField
          label="License Document"
          name="businsess_license_file"
          formik={formik}
        />
        <FileUploadField
          label="VAT Document"
          name="vat_document"
          formik={formik}
        />
        <Box className="step-actions">
          <Button onClick={onBack} className="step-back-btn">
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            endIcon={loading && <CircularProgress size={16} color="inherit" />}
          >
            Save & Continue
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default BusinessStep;
